import { IS_BLUEWHALE, MODULES } from "@/constants";
import { IPermissions } from "@/modules/User/user.interface";

/**
 * What `/dashboard/downloads` (legacy ABM downloads) resolves to for a
 * non-admin user. It needs ABM_STATS on every brand, the same key that gates
 * ABM (Legacy):
 * - Bluewhale (`page`): the downloads page itself.
 * - Other brands (`redirect`): the new ABM report.
 * - No ABM_STATS (`null`): no route, so never redirected into a page the user
 *   cannot open.
 */
export function downloadsRouteMode(
  permission: IPermissions | null | undefined,
  isBluewhale: boolean = IS_BLUEWHALE
): "page" | "redirect" | null {
  if (!permission?.[MODULES.ABM_STATS]) return null;
  return isBluewhale ? "page" : "redirect";
}
